<template>
  <div class="pc-list" ref="list">
    <UniversitySearch @search="search" />
    <div class="pc-head">
      <div class="pc-head-handle">
        <div class="pc-head-btn">
          <button @click="deleteUniversityInit">删除</button>
          <span></span>
          <button @click="addUniversity">添加</button>
          <span></span>
          <button @click="exportUniversity">导出数据</button>
        </div>
        <p>{{ "共" + pagination_options.total + "条" }}</p>
      </div>
    </div>
    <el-table
      class="pc-list-table"
      :data="universityList"
      @sort-change="changeSort"
      v-loading="loading"
    >
      <el-table-column width="90" fixed="left">
        <template slot="header" slot-scope="header">
          <el-checkbox v-model="isSelectAll" @change="selectAll">{{
            "已选" + checked.length + "个"
          }}</el-checkbox>
        </template>
        <template slot-scope="scope">
          <el-checkbox
            v-model="scope.row.isSelect"
            @change="
              singleCheck(
                scope.$index,
                scope.row.isSelect,
                scope.row.id,
                scope.row
              )
            "
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column label="logo" width="100" fixed="left">
        <template slot-scope="scope">
          <div class="eltable-img">
            <img v-if="scope.row.badge_image" :src="scope.row.badge_image" />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="chinese_name"
        label="名称"
        sortable="custom"
        width="160"
        fixed="left"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.chinese_name">
            {{
              scope.row.chinese_name
                ? scope.row.chinese_name
                : scope.row.english_name
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="地域" width="200">
        <template slot-scope="scope">
          {{ scope.row.continent ? scope.row.continent + " " : ""}}
          {{ scope.row.country ? scope.row.country + " " : ""}}
          {{ scope.row.city ? scope.row.city + " " : ""}}
        </template>
      </el-table-column>

      <el-table-column
        prop="id"
        label="WUPEN排名"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="website"
        label="官网"
        width="220"
      ></el-table-column>
      <el-table-column label="状态" prop="status" sortable="custom" width="170">
        <template slot-scope="scope">
          <!-- scope.row.status -->
          <el-switch
            v-model="scope.row.status"
            active-color="#91CC75"
            inactive-color="#C7C7C7"
            @change="changeState(scope.row)"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="更新时间"
        prop="update_time"
        sortable="custom"
        width="120"
      >
        <template slot-scope="scope">
          <div>{{ $dtime(scope.row.update_time).format("YYYY-MM-DD") }}</div>
        </template>
      </el-table-column>
      <el-table-column width="180" fixed="right">
        <template slot-scope="scope">
          <button class="btnViewDetail" @click="viewDetail(scope.row)">
            查看详情
          </button>
        </template>
      </el-table-column>
    </el-table>
    <DeleteHint
      :dialogVisible="deleteDialogVisible"
      @cancel="closeDelete"
      @delete="deleteUniversity"
    />
    <Pagination
      v-if="universityList.length > 0"
      :pagination="pagination_options"
      @goPage="goPage"
    />
  </div>
</template>



<script>
import Pagination from "@/components/componentSet/Pagination";
import UniversitySearch from "./UniversitySearch";
// 导出数据
import {
  UniversitySearch_Api,
  deleteUniversities_Api,
  updateUniversity_Api,
  outputUniversity_Api,
} from "@/apis/university.api";
import DeleteHint from "../../../template/DeleteHint";
export default {
  components: {
    UniversitySearch,
    Pagination,
    DeleteHint,
  },
  watch: {},
  data() {
    return {
      loading: false,
      deleteDialogVisible: false,
      isActive: null,
      searchRules: {
        page: 1,
        page_size: 10,
        order: "-id",
      },
      pagination_options: {
        page: 1,
        total: 0,
        take: 10,
      },
      isSelectAll: false,
      universityList: [],
      checked: [],
    };
  },

  mounted() {
    this.getUniversityListByRules(this.searchRules);
  },
  methods: {
    getUniversityListByRules(data) {
      this.loading = true;
      UniversitySearch_Api(data)
        .then((res) => {
          console.log(res.data);
          this.$set(this.pagination_options, "total", res.count);
          res.data.forEach((el) => {
            el.isSelect = false;
          });
          this.universityList = res.data;
          this.loading = false;
          this.$global.success(this, "获取成功", null);
        })
        .catch(() => {
          this.loading = false;
          this.$global.error(this, "获取失败！", null);
        });
    },
    changeSort(val) {
      if (val.order == "ascending") {
        this.searchRules.order = "+" + val.prop;
      }
      if (val.order == "descending") {
        this.searchRules.order = "-" + val.prop;
      }
      if (val.order == null) {
        this.searchRules.order = "-id";
      }
      this.searchRules.page = 1;
      let data = this.dealSearchRules(this.searchRules);
      this.getUniversityListByRules(data);
      this.pagination_options.page = 1;
    },
    search(formData) {
      console.log(formData);
      this.searchRules = { ...this.searchRules, page: 1, ...formData };
      let data = this.dealSearchRules(this.searchRules);
      console.log(this.searchRules);
      this.getUniversityListByRules(data);
      this.pagination_options.page = 1;
    },
    dealSearchRules(formData) {
      let data = {};
      if (formData.page) {
        data.page = formData.page;
      }
      if (formData.page_size) {
        data.page_size = formData.page_size;
      }
      if (formData.order) {
        data.order = formData.order;
      }
      if (formData.wupen_flag) {
        data.wupen_flag = formData.wupen_flag;
      }
      if (formData.city) {
        data.city = formData.city;
      }
      if (formData.name_keyword) {
        data.name_keyword = formData.name_keyword;
      }
      if (formData.tags_keywords && formData.tags_keywords.length > 0) {
        data.tags_keywords = [...formData.tags_keywords];
      }
      if (formData.status) {
        data.status = parseInt(formData.status);
      }
      return data;
    },
    deleteUniversityInit() {
      if (this.checked.length > 0) {
        this.deleteDialogVisible = true;
      } else {
        this.$global.error(this, "请先勾选要删除的项目！", null);
      }
    },
    addUniversity() {
      let route = this.$router.resolve({
        path: "/admin/schooldetail",
        query: { method: "add" },
      });
      window.open(route.href, "_blank");
    },
    exportUniversity() {
      if (this.checked.length > 0) {
        outputUniversity_Api({ university_id_list: this.checked }).then(
          (res) => {
            this.$global.downloadFile(res, "universityList");
          }
        );
      } else {
        this.$global.error(this, "请先勾选要导出的项目！", null);
      }
    },
    closeDelete() {
      this.deleteDialogVisible = false;
    },
    viewDetail(item) {
      let route = this.$router.resolve({
        path: "/admin/schooldetail",
        query: { id: item.id, method: "update" },
      });
      window.open(route.href, "_blank");
    },
    // 全选按钮
    selectAll() {
      if (this.isSelectAll) {
        this.checked = [];
        this.universityList.forEach((item, i, arr) => {
          this.$set(item, "isSelect", true);
          this.checked.push(item.id);
        });
      } else {
        this.universityList.forEach((item, i, arr) => {
          item.isSelect = false;
          this.checked = [];
        });
      }
    },
    // 单选按钮
    singleCheck(index, isSelect, rowID, row) {
      if (isSelect == false) {
        this.isSelectAll = false;
        for (let i = 0; this.checked.length > i; i++) {
          if (this.checked[i] == rowID) {
            this.checked.splice(i, 1);
            return;
          }
        }
      } else {
        this.checked.push(rowID);
        if (this.checked.length == 10) {
          this.isSelectAll = true;
        }
      }
      console.log(this.checked);
    },
    changeState(row) {
      updateUniversity_Api({ university_id: row.id, status: row.status })
        .then(() => {
          console.log("修改状态成功！");
          this.$global.success(this, "修改状态成功！", null);
        })
        .catch((res) => {
          console.log("修改状态失败！");
        });
    },
    deleteUniversity() {
      let delete_ids = { university_id_list: this.checked };
      console.log("delete_ids:", delete_ids);
      deleteUniversities_Api(delete_ids)
        .then((res) => {
          console.log("批量删除成功！");
          this.checked = [];
          this.deleteDialogVisible = false;
          this.$global.success(this, "删除成功！");
          this.searchRules.page = 1;
          let data = this.dealSearchRules(this.searchRules);
          this.getUniversityListByRules(data);
          this.pagination_options.skip = 0;
        })
        .catch((err) => {
          console.log("批量删除失败！");
        });
    },
    goPage(pageNo) {
      this.pagination_options.page = pageNo;
      this.searchRules.page = pageNo;
      let data = this.dealSearchRules(this.searchRules);
      this.getUniversityListByRules(data);
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-list {
  @include table-head;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/university/components/UniversityTable.vue